export default "__VITE_ASSET__CPMG4lO0__"